import React from 'react'
import { Box, styled } from '@mui/material'
import GenericCard from './Cards/GenericCard'
import GenericCardContent from './Cards/GenericCardContent'
import CardFieldGroup from './Cards/CardFieldGroup'
import { useTranslation } from 'react-i18next'
import OutOfficeField from './Cards/OutOfficeField'

const StyledOfficeCard = styled(Box)({
    marginTop: '10px',
})

const OutOfOfficeCard = ({ oofInfo, handleModalOpen, config }) => {
    const { t } = useTranslation()
    return (
        <StyledOfficeCard>
            <GenericCard
                onClick={config.editable ? handleModalOpen : undefined}
                editable={config.editable}
                showEditOption={config.showEditOption}
            >
                <GenericCardContent>
                    <CardFieldGroup>
                        <OutOfficeField
                            label={t('OoO_Status')}
                            bold
                            oofInfo={oofInfo}
                        />
                    </CardFieldGroup>
                </GenericCardContent>
            </GenericCard>
        </StyledOfficeCard>
    )
}

export default OutOfOfficeCard
